module.exports = __webpack_public_path__ + "img/madera007.41cd7316.jpg";